(function(){
  'use strict';
  const KEY = 'dj_wishlist';
  function read(){ try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; } }
  function write(arr){ try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(e){} }
  function sync(){
    const wl = read();
    document.querySelectorAll('.pcard-heart[data-wishlist-handle]').forEach(btn => {
      const h = btn.dataset.wishlistHandle;
      btn.setAttribute('aria-pressed', wl.includes(h) ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function(e){
    const btn = e.target.closest('.pcard-heart[data-wishlist-handle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.wishlistHandle;
    let wl = read();
    if (wl.includes(handle)) { wl = wl.filter(h => h !== handle); } else { wl.push(handle); }
    write(wl);
    sync();
  });
  document.addEventListener('DOMContentLoaded', sync);
  if (document.readyState !== 'loading') sync();
})();
